module.exports = __webpack_public_path__ + "static/media/Public_01.db390871.jpg";